<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <v-card-title cols="6">User visits for month of {{getPreviousMonth().toUpperCase()}}:</v-card-title>
      <v-spacer></v-spacer>
      <v-col cols="4">
        <v-text-field
          v-model="search"
          label="Search"
          clearable
          solo
          class="ma-4"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="filteredCategoryViews"
      :items-per-page="10"
      :sort-by="['pageViews']"
      :sort-desc="[true]"
      @click:row="openLink"
    ></v-data-table>
  </v-card>
</template>

<script>
import { Strings, axios } from '../../../utils'

export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'CATEGORY',
          align: 'start',
          sortable: true,
          value: 'pageTitle'
        },
        { text: 'HITS', align: 'start', sortable: true, value: 'pageViews' }
      ],
      categoryViews: [],
      search: '', // Add search property
      month: ''
    }
  },
  mounted() {
    this.getCategoryViews()
  },
  computed: {
    filteredCategoryViews() {
      if (!this.search) {
        return this.categoryViews;
      }
      return this.categoryViews.filter(view => 
        view.pageTitle.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    getPreviousMonth() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      
      return monthNames[date.getMonth()];
    },
    openLink(val) {
      window.open('https://bluebusinessguide.com.au/browse/' + this.generateSlug(val.pageTitle, '_blank'));
    },
    generateSlug(category) {
      let slug = category.toLowerCase();
      slug = slug.replace(/\s+/g, '-').replace(/\//g, '-');
      slug = slug.replace(/-+(?=-)/g, '');
      return slug;
    },
    getCategoryViews() {
      this.loading = true;
      axios.get('/api/category-views')
        .then(({data}) => {
          this.categoryViews = data;
          console.log(this.categoryViews.reduce((acc, item) => acc + item.pageViews, 0));
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false;
        });
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=category&name=CATEGORY HITS REPORT`,
        '_blank'
      );
    }
  },
  watch: {
    month: function() {
      this.getCategoryViews();
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
